import { Box, BoxProps } from '@mezzoforte/forge';

export function ShadowBox(props: BoxProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'background',
        borderRadius: 'box',
        boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.15), 0px 2px 4px rgba(0, 0, 0, 0.12)',
        color: 'text',
      }}
      {...props}
    />
  );
}
